import { useEffect, useState } from "react";
import { ArrowRight, Phone } from "lucide-react";

export default function MobileStickyCTA({ label = "Bezpłatna wycena" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after user scrolls past hero (~600px)
      const past = window.scrollY > 520;
      // Hide on final CTA so it doesn't double up
      const finalEl = document.getElementById("final-cta");
      let nearFinal = false;
      if (finalEl) {
        const rect = finalEl.getBoundingClientRect();
        nearFinal = rect.top < window.innerHeight - 80;
      }
      setVisible(past && !nearFinal);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToForm = () => {
    const el = document.getElementById("lead-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    const input = document.getElementById("hero-phone");
    setTimeout(() => input?.focus(), 600);
  };

  return (
    <div
      aria-hidden={!visible}
      className={`lg:hidden fixed inset-x-0 bottom-0 z-30 px-3 pb-3 pt-2 transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
      data-testid="mobile-sticky-cta"
    >
      <button
        type="button"
        onClick={goToForm}
        className="w-full h-14 rounded-full bg-brand-yellow hover:bg-brand-yellowHover active:scale-[0.99] text-brand-yellowFg font-bold text-base shadow-2xl shadow-amber-500/30 flex items-center justify-center gap-2"
        data-testid="mobile-sticky-cta-btn"
      >
        <Phone className="h-5 w-5" />
        {label}
        <ArrowRight className="h-5 w-5" />
      </button>
    </div>
  );
}
